// import React, { Component } from "react";
// import userIcon from "assets/frontend/images/user.png";
// import imageTest from "assets/frontend/images/laravel.png";

// export default class CardContentHome extends Component {
//   render() {
//     return (
//       <div class="row">
//         <div class="col-12 col-md-4 col-lg-3">
//           <div class="card">
//             <div class="card-body">
//               <a href="/details" class="component-content d-block">
//                 <div class="content-thumbnail">
//                   <div
//                     class="content-image"
//                     // style="background-image: url('/images/laravel.png');"
//                   >
//                     <img src={imageTest} class="img-fluid" />
//                   </div>
//                 </div>
//                 <div class="content-title">
//                   Tutorial Laravel : Pengenalan laravel
//                 </div>
//               </a>
//               <div class="divider"></div>
//               <div class="author">
//                 <div class="author-profile">
//                   <img
//                     src={userIcon}
//                     class="profile-picture rounded-circle"
//                     alt=""
//                   />
//                   <p class="author-name">Author</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div class="col-12 col-md-4 col-lg-3">
//           <div class="card">
//             <div class="card-body">
//               <a href="details.html" class="component-content d-block">
//                 <div class="content-thumbnail">
//                   <div
//                     class="content-image"
//                     // style="background-image: url('/images/laravel.png');"
//                   >
//                     <img src={imageTest} class="img-fluid" />
//                   </div>
//                 </div>
//                 <div class="content-title">
//                   Tutorial Laravel : Pengenalan laravel
//                 </div>
//               </a>
//               <div class="divider"></div>
//               <div class="author">
//                 <div class="author-profile">
//                   <img
//                     src={userIcon}
//                     class="profile-picture rounded-circle"
//                     alt=""
//                   />
//                   <p class="author-name">Author</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div class="col-12 col-md-4 col-lg-3">
//           <div class="card">
//             <div class="card-body">
//               <a href="details.html" class="component-content d-block">
//                 <div class="content-thumbnail">
//                   <div
//                     class="content-image"
//                     // style="background-image: url('/images/laravel.png');"
//                   >
//                     <img src={imageTest} class="img-fluid" />
//                   </div>
//                 </div>
//                 <div class="content-title">
//                   Tutorial Laravel : Pengenalan laravel
//                 </div>
//               </a>
//               <div class="divider"></div>
//               <div class="author">
//                 <div class="author-profile">
//                   <img
//                     src={userIcon}
//                     class="profile-picture rounded-circle"
//                     alt=""
//                   />
//                   <p class="author-name">Author</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div class="col-12 col-md-4 col-lg-3">
//           <div class="card">
//             <div class="card-body">
//               <a href="details.html" class="component-content d-block">
//                 <div class="content-thumbnail">
//                   <div
//                     class="content-image"
//                     // style="background-image: url('/images/laravel.png');"
//                   >
//                     <img src={imageTest} class="img-fluid" />
//                   </div>
//                 </div>
//                 <div class="content-title">
//                   Tutorial Laravel : Pengenalan laravel
//                 </div>
//               </a>
//               <div class="divider"></div>
//               <div class="author">
//                 <div class="author-profile">
//                   <img
//                     src={userIcon}
//                     class="profile-picture rounded-circle"
//                     alt=""
//                   />
//                   <p class="author-name">Author</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

import React, { Component } from "react";
import userIcon from "assets/frontend/images/user.png";
import imageTest from "assets/frontend/images/laravel.png";
import { Link } from "react-router-dom";

export default class CardContentHome extends Component {
  render() {
    const imageContent = {
      backgroundImage: "url(" + imageTest + ")",
    };
    return (
      <div className="row mb-5">
        <div className="col-12 col-md-4 col-lg-3">
          <div className="card mt-2 mb-2">
            <div className="card-body">
              <Link to="/detail" className="component-content d-block">
                <div className="content-thumbnail">
                  <div className="content-image" style={imageContent}></div>
                </div>
                <div className="content-title">
                  Tutorial Laravel : Pengenalan laravel
                </div>
              </Link>
              <div className="divider"></div>
              <div className="author">
                <div className="author-profile">
                  <img
                    src={userIcon}
                    className="profile-picture rounded-circle"
                    alt=""
                  />
                  <p className="author-name">Author</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-4 col-lg-3">
          <div className="card mt-2 mb-2">
            <div className="card-body">
              <Link to="/detail" className="component-content d-block">
                <div className="content-thumbnail">
                  <div className="content-image" style={imageContent}></div>
                </div>
                <div className="content-title">
                  Tutorial Laravel : Pengenalan laravel
                </div>
              </Link>
              <div className="divider"></div>
              <div className="author">
                <div className="author-profile">
                  <img
                    src={userIcon}
                    className="profile-picture rounded-circle"
                    alt=""
                  />
                  <p className="author-name">Author</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-4 col-lg-3">
          <div className="card mt-2 mb-2">
            <div className="card-body">
              <Link to="/detail" className="component-content d-block">
                <div className="content-thumbnail">
                  <div className="content-image" style={imageContent}></div>
                </div>
                <div className="content-title">
                  Tutorial Laravel : Pengenalan laravel
                </div>
              </Link>
              <div className="divider"></div>
              <div className="author">
                <div className="author-profile">
                  <img
                    src={userIcon}
                    className="profile-picture rounded-circle"
                    alt=""
                  />
                  <p className="author-name">Author</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-4 col-lg-3">
          <div className="card mt-2 mb-2">
            <div className="card-body">
              <Link to="/detail" className="component-content d-block">
                <div className="content-thumbnail">
                  <div className="content-image" style={imageContent}></div>
                </div>
                <div className="content-title">
                  Tutorial Laravel : Pengenalan laravel
                </div>
              </Link>
              <div className="divider"></div>
              <div className="author">
                <div className="author-profile">
                  <img
                    src={userIcon}
                    className="profile-picture rounded-circle"
                    alt=""
                  />
                  <p className="author-name">Author</p>
                </div>
              </div>
            </div>
          </div>
        </div>
       
       

      </div>

      

      
    );
  }
}
